import { withDisplayName } from '@hocs/with-display-name'
import { CtaLink } from '@ui/cta-link'
import { EnhancedButton } from '@ui/enhanced-components/enhanced-components'
import {
  ENHANCED_COMPONENT_ROLE,
  ENHANCED_COMPONENT_TYPE,
} from '@ui/enhanced-components/types'
import { getPath } from '@utils/get-path'
import clsx from 'clsx/lite'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulCtaSecondaryRefresh: Utils.EntryFC<
  Queries.ContentfulCtaSecondaryRefreshFragment
> = ({ content: { text, type, externalLink, internalLink } }) => {
  const href = getPath(internalLink) || externalLink || undefined
  switch (type) {
    case 'link': {
      return (
        <CtaLink
          data-role={ENHANCED_COMPONENT_ROLE.SECONDARY}
          data-type={ENHANCED_COMPONENT_TYPE.CTA}
          href={href}
        >
          {text}
        </CtaLink>
      )
    }

    case 'button': {
      return (
        <EnhancedButton
          data-role={ENHANCED_COMPONENT_ROLE.SECONDARY}
          data-type={ENHANCED_COMPONENT_TYPE.CTA}
          href={href}
          className={clsx(
            '!m-auto !flex !min-h-[40px] !w-full',
            '!max-w-[334px] !border-none !bg-[#8FD448]',
            '!px-8 !py-0 !text-[#003500] [&>div]:overflow-visible'
          )}
        >
          {text}
        </EnhancedButton>
      )
    }

    default: {
      return <></>
    }
  }
}

export const query = graphql`
  fragment ContentfulCtaSecondaryRefresh on ContentfulCta {
    ...ContentfulEntry
    text
    type
    internalLink {
      ...ContentfulBlogTagLink
      ...ContentfulBlogArticleLink
      ...ContentfulDeprecatedPageLink
      ...ContentfulStaticPageLink
    }
    externalLink
  }
`

export default withDisplayName(
  ContentfulCtaSecondaryRefresh,
  'ContentfulCtaSecondaryRefresh'
)
